import ar from "./ar";
import en from "./en";

export const trans = (stringName, langId) => {
    let langData = langId == 2 ? ar : en;
   return langData[stringName] || stringName
}


// WEBPACK FOOTER //
// ./src/helper/trans/trans.js